// extracted by mini-css-extract-plugin
module.exports = {"notification":"FormNotification_notification__D0aYR","message":"FormNotification_message__BmU9X"};